import type {RowData, Table as ReactTable} from '@tanstack/react-table';

export type TableFilterOption = {
  label: string;
  value: string;
};

export type TableSelectFilterMeta<TData extends RowData = RowData> = {
  type: 'select';
  label?: string;
  options:
    | TableFilterOption[]
    | ((table: ReactTable<TData>) => TableFilterOption[]);
};

export type TableTextFilterMeta = {
  type: 'text';
  label?: string;
  placeholder?: string;
};

export type TableFilterMeta<TData extends RowData = RowData> =
  | TableSelectFilterMeta<TData>
  | TableTextFilterMeta;

export function getTextFilterValue(value: unknown) {
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return value.toString();

  return null;
}
